interface DatiOra {
    name: string;
    group: string;
    color: string,
    data: number[];
}
export function predictiveMock() {     
      const giorni = 7;
      const oreGiorno = 24;
      const datiMockati: DatiOra[] = [];
      
      for (let ora = 1; ora <= oreGiorno; ora++) {
        // Genera dati di consumo per ogni ora del giorno
        const datiConsumo: DatiOra = {
            name: `Consumo ore ${ora.toString().padStart(2, '0')}`,
            group: ora.toString().padStart(2, '0'),
            color: '#269ffb',
            data: []
        };
      
        // Genera dati di produzione solo per le ore soleggiati
        const datiProduzione: DatiOra = {
          name: `Produzione ore ${ora.toString().padStart(2, '0')}`,
          group: ora.toString().padStart(2, '0'),
          color: '#26e7a5',
          data: []
        };
      
        for (let giorno = 1; giorno <= giorni; giorno++) {
          // Genera dati di consumo per ogni giorno
          const consumo: number = Math.floor(Math.random() * 100000) + 40000;
          datiConsumo.data.push(consumo);
      
          // Genera dati di produzione solo per le ore soleggiati
          if (ora >= 6 && ora <= 18) {
            const produzione: number = Math.floor(Math.random() * 60000) + 20000;
            datiProduzione.data.push(produzione);
          }
        }
      
        // Aggiungi oggetti dati all'array principale
        datiMockati.push(datiConsumo);
        datiMockati.push(datiProduzione);
      }
      
      console.log(datiMockati);
      
    return datiMockati;
}